import { Component } from '@angular/core';

@Component({
  selector: 'sn-auth',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./auth.view.scss'],

})
export class AuthView {
  constructor() {}
}
